<template>
	<div class="areaselect Flexalign" v-loading="loading">
		<!-- 地区选择  -->
		<div class="area_item"> 
			<el-select v-model="area_val1" class="input_W470" @change="areaChange($event, 1)" clearable >
				<el-option v-for="(item, index) in arealist1" :label="item.name" :value="item.area_id">
				</el-option>
			</el-select>
		</div>
		
		<div class="area_item">
			<el-select :disabled="!area_val1" v-model="area_val2" class="input_W470" @change="areaChange($event, 2)" clearable>
				<el-option v-for="(item, index) in arealist2" :label="item.name" :value="item.area_id">
				</el-option>
			</el-select>
		</div>
		
		<div class="area_item">
			<el-select :disabled="!area_val1 || !area_val2" v-model="area_val3" class="input_W470" @change="areaChange($event, 3)" clearable>
				<el-option v-for="(item, index) in arealist3" :label="item.name" :value="item.area_id">
				</el-option>
			</el-select>
		</div>
		
		<div class="address_txt">
			<el-input clearable :maxlength="120"  show-word-limit @change="fnsave"
				v-model="address" placeholder="详细地址">
			</el-input>
		</div>
		
	</div>
</template>

<script>
	var that;
	import {
		
		alertMess,
		handlereq,
		get_area_list
	} from '@src/network/kh_public'
	export default {
		name: 'areaselect',
		props: {
			datas: {
				type: Object | String,
				default: ()=>{
					return {}
				}
			},
		},
		data(){
			return {
				loading: true,
				
				parent_id: 0,
				
				arealist1: [],
				area_val1: '',
				
				arealist2: [],
				area_val2: '',
				
				arealist3: [],
				area_val3: '',
				
				address: '',
			}
		},
		created() {
		
			if(this.datas && this.datas.area_id1) {
				this.initialization()
			}
			else {
				this.getAreaList(0)
			}
			
			
		},
		watch: {
			// datas(){
			// 	this.initialization()
			// },
		},
		methods: {
			fn_findarea(lv){
				let filarr = []
				let area_id = ''
				let res = ''
				if(lv == 1) {
					filarr = this.arealist1
					area_id = this.area_val1
				}
				else if(lv == 2) {
					filarr = this.arealist2
					area_id = this.area_val2
				}
				else if(lv == 3) {
					filarr = this.arealist3
					area_id = this.area_val3
				}
				if(filarr.length && area_id) {
					let index = filarr.findIndex(v=>v.area_id == area_id)
					if(index != -1 && filarr[index]) {
						res = filarr[index].name
					}
				}
				return res;
			},
			fnsave(){
				let res = {
					area_txt1: '',
					area_txt2: '',
					area_txt3: '',
					area_id1: 0,
					area_id2: 0,
					area_id3: 0,
					address: '',
				}
				if(this.area_val1) {
					res.area_txt1 = this.fn_findarea(1) 
					res.area_id1 = this.area_val1
					if(this.area_val2) {
						res.area_txt2 = this.fn_findarea(2) 
						res.area_id2 = this.area_val2
						if(this.area_val3) {
							res.area_txt3 = this.fn_findarea(3) 
							res.area_id3 = this.area_val3
						}
					}
				}
				if(this.address) {
					res.address = this.address
				}
				this.loading = false
				this.$emit('retarea', res)
			},
			areaChange(e, flag){
				console.log('areaChange')
				if(e) {
					if(flag == 3) {
						this.fnsave()
					}
					else {
						this.getAreaList(e) 
					}
				}
				else {
					if(flag == 1) {
						this.arealist2 = []
						this.arealist3 = []
						this.area_val2 = ''
						this.area_val3 = ''
					}
					else if(flag == 2) {
						this.arealist3 = []
						this.area_val3 = ''
					}
				}
				
			},
		
			getAreaList(parent_id, flag){
				this.loading = true
				// flag 是否已有数据
				get_area_list(parent_id).then(res=>{
					if(handlereq(res)) {
						let obj = res.result || [];
						if(obj && obj.length) {
							this.handledata(obj, flag)
						}
					}
				})
			},
			handledata(obj, flag){
				let arr1 = obj.filter(v=>v.deep == 1)
				let arr2 = obj.filter(v=>v.deep == 2)
				let arr3 = obj.filter(v=>v.deep == 3)
				if(arr1 && arr1.length) {
					this.arealist1 = JSON.parse(JSON.stringify(arr1))
					let first_id1 = ''
					console.log(flag,'handledata')
					if(flag) {
						first_id1 = this.area_val1
						this.getAreaList(first_id1, flag) 
					}
					else {
						first_id1 = this.arealist1[0].area_id
						this.area_val1 = first_id1
						this.getAreaList(first_id1) 
					}
					
					
				}
				
				if(arr2 && arr2.length) {
					this.arealist2 = JSON.parse(JSON.stringify(arr2))
					let first_id2 = ''
					if(flag) {
						first_id2 = this.area_val2
						this.getAreaList(first_id2, flag) 
					}
					else {
						first_id2 = this.arealist2[0].area_id
						this.area_val2 = first_id2
						this.getAreaList(first_id2) 
					}
					
				}
				
				if(arr3 && arr3.length) {
					this.arealist3 = JSON.parse(JSON.stringify(arr3))
					if(!flag) {
						this.area_val3 = this.arealist3[0].area_id
					}
				}
				this.fnsave()
			},
			
			// 初始化
			initialization(){
				if(this.datas && this.datas.area_id1) {
					let id1 = this.datas.area_id1
					this.getAreaList(0, true) 
					this.area_val1 = id1
					this.area_val2 = this.datas.area_id2
					this.area_val3 = this.datas.area_id3
				}
				if(this.datas && this.datas.address) {
					this.address = this.datas.address
				}
				
			},
		},
	}
</script>

<style lang="scss" scoped>
	.areaselect{
		.area_item{
			margin-right: 8px;
			/deep/ .el-select{
				width: 210px !important;
				min-width: 210px !important;
			}
			/deep/ .el-input{
				width: 210px !important;
				min-width: 210px !important;
			}
			
		}
		.address_txt{
			/deep/ .el-input{
				// width: 300px !important;
				min-width: 300px !important;
			}
		}
		
	}
	 
</style>